<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/jala-harvest";

export default {
  extends: ModelCreate,
  page: {
    title: "Create JALA Harvest",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_harvests.singular')) }},
    resourceRoute: {default: 'jala_harvests'},
    modelVariable: {default: 'jala_harvest'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
          href: "/jala_harvests",
        },
        {
          text: this.$t("Create New"),
          href: "/jala_harvests/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/harvests', value);
    }
  }
}
</script>
